// extracted by mini-css-extract-plugin
export default {"wrapper":"svgImage-module-wrapper-p3JcS","spinner":"svgImage-module-spinner-erw9Y"};